import * as React from 'react';
import { useState } from 'react';
// import { experimentalStyled as styled } from '@material-ui/core/styles';
import { experimentalStyled as styled } from '@material-ui/core';

import {
    Avatar,
    Box,
    Card,
    Collapse,
    CardContent,
    Grid,
    LinearProgress,
    Typography,
    IconButton,
     CardActions
  } from '@material-ui/core';
  import { orange, green, red } from '@material-ui/core/colors';
  import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
  import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
 



  import Computations from 'src/components/applications/LoanDetails';
  import helper from 'src/utils/helpers';



  const ExpandMore = styled((props) => {
    const { expand, onClick, ...other } = props;
    return <IconButton onClick={onClick} {...other} />;
  })(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  }));









  const TasksProgress = (props) => {
    const [expanded, setExpanded] = useState(false);

    const handleExpandClick = () => {
      setExpanded(!expanded);
    };




    let loan = props.loan;
    let ln = (loan.totalCollected / loan.loanAmount) * 100;

  return (
    <Card
      sx={{ height: '100%' }}
      {...props}
    >
      <CardContent>
        <Grid
          container
          spacing={3}
          sx={{ justifyContent: 'space-between' }}
        >
            
          <Grid item>
          <Box
        className="center-element"
      >
          <Typography
              color="primary"
              variant="h5"
            >
          {loan.loanId}
            </Typography>&nbsp;&nbsp; - &nbsp;&nbsp; <Typography
          variant="h6"
          sx={{
            color: loan.isPaid ? green[900] : red[900],
          }}
        >
         {String(loan.status !== 'Review' ? loan.isPaid ? 'paid' : 'unPAID' : 'Review').toUpperCase()}
        </Typography>
            </Box>
          <Box
        sx={{
          alignItems: 'center',
          pt: 1
        }}
      >
             <Typography
          color="textSecondary"
          variant="caption"
          className="mr-1"
        >
        LOAN AMOUNT
        </Typography>
        <Typography
            variant="h6"
        >
       {helper.toCurrency(loan.loanAmount)}
        </Typography>
      </Box>
      <Box
        sx={{
          alignItems: 'center',
          pt: 1
        }}
      >
          {loan.status !== 'Review' && !loan.isPaid ? <>   <Typography
          color="textSecondary"
          variant="caption"
          className="mr-1"
        >
        BALANCE
        </Typography>
        <Typography
            variant="h6"
        >
       {helper.toCurrency(loan.loanAmount - loan.totalCollected)}
        </Typography> </> :  <>   <Typography
          color="textSecondary"
          variant="caption"
          className="mr-1"
        >
       STATUS 
        </Typography>
        <Typography
            variant="h6"
            className={ loan.status === 'Review' ? 'text-danger' : 'text-success'}
        >
          {loan.status === 'Review' ? 'For Approval' : 'Paid'}
        </Typography> </> }
        
      </Box>
     
          </Grid>
          <Grid item>
            <Avatar
              sx={{
                backgroundColor: orange[600],
                height: 56,
                width: 56
              }}
            >
              <AccountBalanceWalletIcon />
            </Avatar>
          </Grid>
        </Grid>
        { loan.status !== 'Review' && <Box sx={{ pt: 1 }}>
          <LinearProgress
            value={ln}
            variant="determinate"
          />
        </Box>}
      </CardContent>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Computations data={loan}/>       
      </Collapse>
      <CardActions className="center-element p-1">
      <ExpandMore
          expand={expanded}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon color="primary" />
        </ExpandMore>
      </CardActions>
    </Card>
  );
        }
  export default TasksProgress;
  
  